/**
 * External dependencies
 */
import cx from 'classnames';
import { Link } from '@inertiajs/react';
import { forwardRef } from 'react';

// defaultLink prop is to directly consider it as Link. Because when we use ziggy route it generates it with https.
const Button = forwardRef(
    (
        {
            type = 'button',
            className = '',
            href,
            processing,
            children,
            onClick,
            defaultLink = false,
            addDefaultBtnClass = true,
            ...props
        },
        ref
    ) => {
        const isExternalLink =
            !defaultLink &&
            href &&
            (href.search('http') !== -1 || href.search('mailto:') !== -1 || href.search('tel:+') !== -1);

        const commonProps = {
            className: cx({
                'btn': addDefaultBtnClass,
                'opacity-60': processing,
                [className]: className,
            }),
            ref,
            ...props,
        };

        return href ? (
            isExternalLink ? (
                <a href={href} {...commonProps}>
                    {children}
                </a>
            ) : (
                <Link href={href} {...commonProps}>
                    {children}
                </Link>
            )
        ) : (
            <button type={type} onClick={onClick} disabled={processing} {...commonProps}>
                {children}
            </button>
        );
    }
);

export default Button;
